<app-sitreps-table [sitreps]="sitreps$ | async" (ackSitrep)="ackSitrep($event)" (openBody)="openBody($event)"
    (doneSitrep)="doneSitrep($event)"></app-sitreps-table>